const scriptForms = {}

scriptForms.getDivEvents = () => {
  return `
  <div id="keybe-events"></div>
  <div id="keybe"></div>
  `
}

scriptForms.getDivForms = () => {
  return `
  <div id="keybe"></div>
  <div id="keybe-forms"></div>
  `
}

scriptForms.getDivKeybeUi = () => {
  return `
  <div id="keybe"></div>
`
}

scriptForms.getScriptChat = (clientKey) => {
  return `
  <script src="https://storage.googleapis.com/keybejs/${process.env.VUE_APP_NODE_ENV === 'development' ? 'test_' : ''}${process.env.VUE_APP_VERSION}/keybe.js?version=${process.env.VUE_APP_VERSION}"></script>

  <script>
      var configChat = {
          apiKey: '${clientKey}'
      }
      window.keybe.webchatConversationsUiLoad(configChat)
  </script>
  `
}

scriptForms.getScriptChatCloudTask = (clientKey) => {
  return `
  <script src="https://storage.googleapis.com/keybejs/${process.env.VUE_APP_NODE_ENV === 'development' ? 'test_' : ''}${process.env.VUE_APP_VERSION}/keybe.js?version=${process.env.VUE_APP_VERSION}"></script>

  <script>
      var configChat = {
          apiKey: '${clientKey}',
          isCloudTask: true
      }
      window.keybe.webchatConversationsUiLoad(configChat)
  </script>
  `
}

scriptForms.getScriptEvents = (clientKey) => {
  return `
  <script src="https://storage.googleapis.com/keybejs/${process.env.VUE_APP_NODE_ENV === 'development' ? 'test_' : ''}${process.env.VUE_APP_VERSION}/keybe.js?version=${process.env.VUE_APP_VERSION}"></script>

  <script type="application/javascript">
      var configEvents = { apiKey: '${clientKey}' };
      window.keybe.initializeApp(configEvents);
      window.keybe.eventsUiLoad();
  </script>
  `
}

scriptForms.getScriptForms = (clientKey, formId, settings) => {
  return `
  <script src="https://storage.googleapis.com/keybejs/${process.env.VUE_APP_NODE_ENV === 'development' ? 'test_' : ''}${process.env.VUE_APP_VERSION}/keybe.js?version=${process.env.VUE_APP_VERSION}"></script>

  <script>
      var configForms = {
          apiKey: '${clientKey}',
          formId: '${formId}',
          color: '${settings.color || ''}',
          sendButtonAlignment: '${settings.sendButtonAlignment || 'left'}',
          sendButtonLabel: '${settings.sendButtonLabel || 'Enviar'}',
          sendButtonSize: '${settings.sendButtonSize || ''}',
          style: '${settings.style || 'regular'}',
          submitSuccessText: '${settings.submitSuccessText}'
      }

      window.keybe.formsUiLoad(configForms)
  </script>
  `
}

scriptForms.getScriptKeybeUi = (clientKey) => {
  return `
  <script src="https://storage.googleapis.com/keybejs/${process.env.VUE_APP_NODE_ENV === 'development' ? 'test_' : ''}${process.env.VUE_APP_VERSION}/keybe.js?version=${process.env.VUE_APP_VERSION}"></script>

  <script>
      var configKeybeUi = {
          apiKey: '${clientKey}'
      }
      window.keybe.uiLoad(configKeybeUi)
  </script>
  `
}

scriptForms.getElementClickable = () => {
  return `
  <script>
      var x = document.getElementsByClassName('keybe-signup')
      for (var i = 0; i < x.length; i++) {
          x[i].addEventListener('click', function(e) {
              e.preventDefault()
              e.stopPropagation()
              window.keybe.uiOpenModal()
          })
      }
  </script>
  `
}

export default scriptForms
